import { Entity, IEntity } from '../entity';
import { ILanguage, Language } from '../translations';
import { OrganizationUnitTypeData } from './organization-unit-type-data';
import { OrganizationUnitTypeType } from '../../types';
import { IOrganizationUnitFile, OrganizationUnitFile } from './organization-unit-file';
import { hasHtmlContent, plainTextFromHtml } from '../../../Utils/html-sanitize.utils';

export interface IOrganizationUnit extends IEntity {
  id: string;
  name: string;
  language: ILanguage | undefined;
  type: string;
  editable: boolean;
  climateProfileFile: IOrganizationUnitFile | null;
  challengesAndConcernsFile: IOrganizationUnitFile | null;
  description?: string | null;
  comments?: string;
}

export class OrganizationUnit extends Entity implements IOrganizationUnit {
  name: string;
  language: Language | undefined;
  type: OrganizationUnitTypeType;
  climateProfileFile: OrganizationUnitFile | null;
  challengesAndConcernsFile: OrganizationUnitFile | null;
  description?: string | null;
  comments?: string;
  readonly commentsIncluded: boolean;

  get hasClimateProfileFile(): boolean {
    return this.climateProfileFile !== null;
  }

  get hasChallengesAndConcernsFile(): boolean {
    return this.challengesAndConcernsFile !== null;
  }

  get editable() {
    return this.type !== OrganizationUnitTypeData.getByName('xunta')?.name &&
      this.type !== OrganizationUnitTypeData.getByName('technicalOffice')?.name;
  }

  get hasComments(): boolean {
    return this.commentsIncluded && hasHtmlContent(this.comments);
  }

  get commentsText(): string {
    return plainTextFromHtml(this.comments);
  }

  constructor(data: IOrganizationUnit) {
    super(data);
    this.name = data.name;
    this.type = data.type;
    this.language = data.language != null
      ? new Language(data.language)
      : undefined
    this.climateProfileFile = data.climateProfileFile != null
      ? new OrganizationUnitFile(data.climateProfileFile)
      : null;
    this.challengesAndConcernsFile = data.challengesAndConcernsFile != null
      ? new OrganizationUnitFile(data.challengesAndConcernsFile)
      : null;
    this.description = data.description;
    this.commentsIncluded = data != null && 'comments' in data;
    if (this.commentsIncluded) {
      this.comments = data.comments;
    }
  }
}
